// extracted by mini-css-extract-plugin
export default {"EmptyState":"styles_EmptyState__cTVXt","EmptyState--main":"styles_EmptyState--main__l0V4J","EmptyState--main__trigger":"styles_EmptyState--main__trigger__00MYq"};